import { apiClient } from '@/api/apiClient'
import { useQuery } from '@tanstack/react-query'
import { UserRole } from '@/api/models/UserModel'
import { DeclarantType } from '@/features/cbam-reporting/hooks/declarants'

export type OrganizationUser = {
  id: string
  email: string
  firstName: string
  lastName: string
  isEmailVerified: boolean
  role: UserRole
  declarants: {
    declarantId: string
    name: string
    type: DeclarantType
  }[]
}

export const ORGANIZATION_USERS_QUERY_KEY = 'organizationUsers'

export const useGetOrganizationUsers = (organizationId: string) => {
  return useQuery({
    queryKey: [ORGANIZATION_USERS_QUERY_KEY, organizationId],
    queryFn: async () => {
      const response = await apiClient.get<OrganizationUser[]>(
        `/v2/organizations/${organizationId}/users`
      )
      return response.data
    },
    enabled: !!organizationId
  })
}
